// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1315s","error":"Textarea_error__FVwjn","readonly":"Textarea_readonly__Ql8xd","disabled":"Textarea_disabled__1f2zJ"};